import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, type: 'spring', stiffness: 100 }}
      className={`fixed top-0 left-0 right-0 z-50 px-4 py-3 transition-all duration-300 ${isScrolled ? 'bg-[#007BFF] shadow-lg' : 'bg-transparent'}`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="flex items-center"
        >
          <motion.div 
            whileHover={{ scale: 1.1, rotate: [0, -5, 5, -5, 0] }}
            transition={{ duration: 0.3 }}
            className="bg-white p-2 rounded-lg shadow-lg mr-3"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#007BFF]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h8M9.5 13.5h5" />
            </svg>
          </motion.div>
          <h1 className="text-xl md:text-2xl font-bold text-white">CityPoints</h1>
        </motion.div>

        {/* Menu desktop */}
        <motion.nav 
          variants={navVariants}
          initial="hidden"
          animate="visible"
          className="hidden md:flex items-center space-x-6"
        >
          {['Accueil', 'Boutiques', 'Mes Points', 'Offres', 'Contact'].map((item, index) => (
            <motion.a
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.1, color: '#40E0D0' }}
              href="#"
              className="text-white font-medium hover:text-[#40E0D0] transition-colors"
            >
              {item}
            </motion.a>
          ))}
          <motion.button
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-5 py-2 bg-[#7B1FA2] text-white rounded-lg shadow-lg hover:bg-[#6A1B9A] transition-colors"
          >
            Connexion
          </motion.button>
        </motion.nav>

        {/* Menu hamburger pour mobile */}
        <div className="md:hidden">
          <button 
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-white focus:outline-none"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {menuOpen 
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              }
            </svg>
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      {menuOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="md:hidden bg-[#007BFF] mt-3 py-4 px-4 rounded-lg shadow-xl"
        >
          <nav className="flex flex-col space-y-4">
            {['Accueil', 'Boutiques', 'Mes Points', 'Offres', 'Contact'].map((item, index) => (
              <a
                key={index}
                href="#"
                className="text-white font-medium py-2 px-3 hover:bg-[#0056b3] rounded-md transition-colors"
              >
                {item}
              </a>
            ))}
            <button className="mt-2 w-full py-3 bg-[#7B1FA2] text-white rounded-lg shadow-lg hover:bg-[#6A1B9A] transition-colors">
              Connexion
            </button>
          </nav>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;
